import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const PublicRoute = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (localStorage.getItem("token")) {
            const previousPath = location.state?.from || "/dashboard";
            navigate(previousPath, { replace: true });
        }
    }, [navigate, location]);

    return <div>{children}</div>;
}

export default PublicRoute;
